// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"_1-z"};